import { Box, Drawer, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import BoardIDEffects from 'BoardIDEffects';
import { DRAWER_BREAKPOINT, SIDEBAR_WIDTH } from 'Constants';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import ButtonBar from 'designer/ButtonBar';
import Editor from 'designer/Editor';
import LeftPanel from 'designer/LeftPanel';
import NewBoardModal from 'designer/NewBoardModal';
import { useUndo } from 'state/recoilBoardActions';
import { selectedBoardIDAtom } from 'state/recoilState';
import { useSelectedBoardInstance } from 'utils/hooks';

function Designer() {
  const selectedBoardID = useRecoilValue(selectedBoardIDAtom);
  const selectedBoardInstance = useSelectedBoardInstance();

  const theme = useTheme();
  const isSidebarShown = useMediaQuery(theme.breakpoints.up(DRAWER_BREAKPOINT));

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    setIsDrawerOpen(isSidebarShown);
  }, [isSidebarShown, setIsDrawerOpen]);

  const undo = useUndo();

  useEffect(() => {
    function bodyKeyDownHandler(event: KeyboardEvent) {
      if (event.metaKey && event.key === 'z') {
        undo(selectedBoardID);
      }
    }

    document.body.addEventListener('keydown', bodyKeyDownHandler);

    return () => {
      document.body.removeEventListener('keydown', bodyKeyDownHandler);
    };
  }, [selectedBoardID, undo]);

  return (
    <>
      <BoardIDEffects />
      <NewBoardModal />

      <Drawer
        open={isDrawerOpen}
        style={{
          isolation: 'isolate',
          width: isDrawerOpen ? SIDEBAR_WIDTH : 0,
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
        variant="persistent"
      >
        {/* This is just a spacer */}
        <Toolbar />
        <LeftPanel />
      </Drawer>

      <Box sx={{ flex: 1, minWidth: 0, mx: 2 }}>
        <ButtonBar />

        {selectedBoardInstance && (
          <Editor boardInstance={selectedBoardInstance} />
        )}
      </Box>
    </>
  );
}

export default Designer;
